import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { MTOComponentHdrContainerModel } from '../../../../../../models/aggregates/erp/mto/mto-component-hdr-container.model';

@Injectable({
  providedIn: 'root'
})
export class MTOComponentHdrService extends BaseApiTemplateService<MTOComponentHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'components';
  readonly endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'components/' + Core2Config.PUBLIC_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'components';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'components';
    this.httpClient = http;
  }

  getByCriteriaPublic(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MTOComponentHdrContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}

